import React from 'react';
import { ExternalLink, Clock } from 'lucide-react';

const SOURCE_COLORS = {
  substack: 'bg-orange-200',
  twitter: 'bg-blue-200',
  blog: 'bg-green-200',
  podcast: 'bg-purple-200',
};

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const diff = Math.floor((Date.now() - date) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function stripHtml(html) {
  if (!html) return '';
  const text = html.replace(/<[^>]*>/g, '');
  return text.length > 200 ? text.substring(0, 200) + '...' : text;
}

export function FeedEntry({ entry, index }) {
  return (
    <a
      href={entry.link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`feed-entry-${index}`}
      className="block brutalist-card group cursor-pointer animate-slide-up"
      style={{ animationDelay: `${index * 30}ms` }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className={`source-badge ${SOURCE_COLORS[entry.source_type] || 'bg-zinc-200'}`}>
              {entry.source_type}
            </span>
            <span className="text-xs font-bold text-zinc-500 uppercase">{entry.source_title}</span>
            <span className="flex items-center gap-1 text-xs text-zinc-400">
              <Clock strokeWidth={2.5} size={10} />
              {timeAgo(entry.published_at)}
            </span>
          </div>
          <h3 className="text-base sm:text-lg font-bold text-zinc-900 group-hover:text-pink-600 transition-colors leading-snug mb-2">
            {entry.title}
          </h3>
          {entry.description && (
            <p className="text-sm text-zinc-600 font-medium leading-relaxed">
              {stripHtml(entry.description)}
            </p>
          )}
          {entry.author && (
            <p className="text-xs text-zinc-400 font-medium mt-2">by {entry.author}</p>
          )}
        </div>
        <ExternalLink strokeWidth={2.5} size={18} className="flex-shrink-0 text-zinc-300 group-hover:text-pink-500 transition-colors mt-1" />
      </div>
    </a>
  );
}
